import { Badge } from "@/components/Badge";
import type { Readiness } from "@/types";

interface Props {
  readiness: Readiness | null | undefined;
  stage?: string | null;
  // Interruttori auto-invio (globale + agenzia) dal backend: a false una pratica
  // pronta non parte da sola.
  autoAttivo?: boolean;
}

// Stage già nella pipeline A2A o conclusi: nessun badge readiness (lo stato lo
// dice già il badge di stage) — mirror di _STAGE_GIA_INVIATA in
// backend/app/a2a_autoinvia/predicate.py.
const STAGE_GIA_INVIATA = ["Inserita", "In attivazione", "Accettata", "Attivata", "Annullata"];

// Badge di riga lista pratiche: stato dell'invio automatico ad A2A.
// - stage già inviato/concluso → nessun badge
// - !applicabile → chip grigio "Invio manuale" (pratica fuori dal perimetro auto-invio)
// - applicabile && pronta && auto acceso → verde "Pronta — invio automatico"
// - applicabile && pronta && auto spento → ambra "Pronta — da inviare a mano"
//   (il verde in questa lista significa "non devi fare niente": se l'invio va
//   spinto a mano c'è un'azione pendente, quindi ambra come "Da completare")
// - applicabile && !pronta → ambra "Da completare: <primo mancante>…"
export function ReadinessBadge({ readiness, stage, autoAttivo = false }: Props) {
  if (stage && STAGE_GIA_INVIATA.includes(stage)) {
    return null;
  }
  if (!readiness || !readiness.applicabile) {
    return (
      <Badge bg="bg-gray-100" text="text-muted-foreground">
        Invio manuale
      </Badge>
    );
  }
  if (readiness.pronta) {
    return autoAttivo ? (
      <Badge bg="bg-green-100" text="text-green-800">
        Pronta — invio automatico
      </Badge>
    ) : (
      <Badge bg="bg-amber-100" text="text-amber-800">
        Pronta — da inviare a mano
      </Badge>
    );
  }
  const primo = readiness.manca[0] ?? "dati mancanti";
  return (
    <Badge bg="bg-amber-100" text="text-amber-800">
      Da completare: {primo}…
    </Badge>
  );
}
